import { User } from 'Models';

export class ManagedReviewer {
  doctorAdmin?: User;
  managedReviewer?: User;
}
